// extracted by mini-css-extract-plugin
export default {"section":"section---gb_32","active":"active---LiMS6","marginRight":"marginRight---KGLUM","userPlaceholder":"userPlaceholder---Ro2Ql"};